import * as React from 'react'

/**
 * useState backed by localStorage — for per-viewer conveniences (collapsed
 * groups, vault scope) that should survive a reload. Storage can throw in
 * private mode or when blocked; the state still works, it just won't persist.
 */
export default function usePersistentState<T>(
  key: string,
  initial: T,
): [T, (next: T | ((prev: T) => T)) => void] {
  const [value, setValue] = React.useState<T>(() => {
    try {
      const raw = localStorage.getItem(key)
      return raw === null ? initial : (JSON.parse(raw) as T)
    } catch {
      return initial
    }
  })

  React.useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // Nothing to do — see above.
    }
  }, [key, value])

  return [value, setValue]
}
